class ProductColours extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleThemeTrigger = this.handleThemeTrigger.bind(this)
    this.handleCardTrigger = this.handleCardTrigger.bind(this)

    this.els['theme-trigger']?.elements.forEach((themeTriggerEl) => {
      this.listeners.add(themeTriggerEl, 'click', this.handleThemeTrigger)
    })
    this.els['card-trigger']?.elements.forEach((cardTriggerEl) => {
      this.listeners.add(cardTriggerEl, 'click', this.handleCardTrigger)
    })
  }

  async handleThemeTrigger (event) {
    const triggerEl = event.target.closest(this.els['theme-trigger'].selector)
    const card = triggerEl.closest('[data-product-card]')
    const cardMediaContainer = card?.querySelector('[data-product-card-media]')

    if (cardMediaContainer) {
      cardMediaContainer.setAttribute(
        'data-disabled',
        triggerEl.getAttribute('aria-disabled'),
      )
    }

    const productCardElements = window.BAO.Utils.getElements(
      '[data-product-colours-el="theme"]',
    )

    const productCardColours = window.BAO.Utils.getElements(
      '[data-product-colours-el="theme-trigger"]',
    )

    const productCardPrices = window.BAO.Utils.getElements(
      '[data-product-colours-el="theme-price"]',
    )

    if (productCardElements) {
      productCardElements.forEach((productCardEl) => {
        const parentCard = productCardEl.closest('[data-product-card]')

        // Check if the product has an element with selected colour
        const hasColour = Array.from(
          parentCard.querySelectorAll('[data-colour]'),
        ).some((el) => el.dataset.colour === triggerEl.dataset.colour)

        // Skip this product card if trigger colour isn't available
        if (triggerEl.dataset.colour && !hasColour) {
          return
        }

        productCardEl.setAttribute(
          'aria-hidden',
          productCardEl.dataset.colour !== triggerEl.dataset.colour,
        )
      })
    }

    if (productCardColours) {
      productCardColours.forEach((productCardColour) => {
        const parentCard = productCardColour.closest('[data-product-card]')

        if (productCardColour.dataset.colour === triggerEl.dataset.colour) {
          const cardMediaContainer = parentCard?.querySelector(
            '[data-product-card-media]',
          )

          if (cardMediaContainer) {
            cardMediaContainer.setAttribute(
              'data-disabled',
              productCardColour.getAttribute('aria-disabled'),
            )
          }
        }

        // Check if the product has an element with selected colour
        const hasColour = Array.from(
          parentCard.querySelectorAll('[data-colour]'),
        ).some((el) => el.dataset.colour === triggerEl.dataset.colour)

        // Skip this product card if trigger colour isn't available
        if (triggerEl.dataset.colour && !hasColour) {
          return
        }

        productCardColour.setAttribute(
          'aria-pressed',
          productCardColour.dataset.colour === triggerEl.dataset.colour,
        )
      })
    }

    if (productCardPrices) {
      productCardPrices.forEach((productCardPriceEl) => {
        productCardPriceEl.setAttribute(
          'aria-current',
          productCardPriceEl.dataset.colour === triggerEl.dataset.colour,
        )
      })
    }

    await window.BAO.Cart.updateCartAttributes({
      card_image_colour: `${triggerEl.dataset.colour}`,
    })
  }

  handleCardTrigger (event) {
    const triggerEl = event.target.closest(this.els['card-trigger'].selector)
    const card = triggerEl.closest('[data-product-card]')
    const cardMediaContainer = card.querySelector('[data-product-card-media]')
    const colourTitles = this.els['colour-title']?.elements

    if (cardMediaContainer) {
      cardMediaContainer.setAttribute(
        'data-disabled',
        triggerEl.getAttribute('aria-disabled'),
      )
    }

    if (colourTitles) {
      colourTitles.forEach((colourTitle) => {
        colourTitle.setAttribute(
          'aria-hidden',
          colourTitle.dataset.colour !== triggerEl.dataset.colour,
        )
      })
    }

    const productCardElements = window.BAO.Utils.getElements(
      `[data-product-colours-el="card"][data-product-id="${triggerEl.dataset.productId}"]`,
      { context: card },
    )

    const productCardColours = window.BAO.Utils.getElements(
      `[data-product-colours-el="card-trigger"][data-product-id="${triggerEl.dataset.productId}"]`,
      { context: card },
    )

    const productCardPrices = window.BAO.Utils.getElements(
      `[data-product-colours-el="card-price"][data-product-id="${triggerEl.dataset.productId}"]`,
      { context: card },
    )

    productCardElements.forEach((productCardEl) => {
      productCardEl.setAttribute(
        'aria-hidden',
        productCardEl.dataset.colour !== triggerEl.dataset.colour,
      )
    })

    productCardColours.forEach((productCardColour) => {
      productCardColour.setAttribute(
        'aria-pressed',
        productCardColour.dataset.colour === triggerEl.dataset.colour,
      )
    })

    if (productCardPrices) {
      productCardPrices.forEach((productCardPriceEl) => {
        productCardPriceEl.setAttribute(
          'aria-current',
          productCardPriceEl.dataset.colour === triggerEl.dataset.colour,
        )
      })
    }
  }
}

if (!customElements.get('product-colours')) {
  customElements.define('product-colours', ProductColours)
}
